// @ts-nocheck 
import "./YoutubeEmbed.scss";

interface YoutubeEmbedParams {
    link: string,
    title: string,
    id: string,
    height?: string,
    width?: string,
    fullWidth?: boolean,
    allowFS?: boolean,
}

const YoutubeEmbed = ({link, title, id, height='315', width='', fullWidth=false, allowFS=true}: YoutubeEmbedParams) => {

    return (
        <div className={"youtube-embed"}>
            <iframe 
                className={fullWidth? '':'iframe'}
                height={height}
                width={width}
                src={link} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                 allowFullScreen ={allowFS}
                style={
                    {
                        border: "0px",
                    }
                }
                title = {title}
                id = {id}
                loading={"lazy"}
                frameborder="0"

            ></iframe>
            {/* <img src={"https://img.youtube.com/vi/Yom8-wuqTp4/hqdefault.jpg"} alt={"yt-embed"}/> */}
        </div>
    )
}

export default YoutubeEmbed;